import apiClient from '../plugins/axios';

/**
 * STT Service – POST /stt/transcribe, authenticated via the signed-in user's Bearer token.
 */
class SttService {
  /**
   * Transcribe audio. POST /stt/transcribe – multipart file.
   * @param {File} file
   * @returns {Promise<{ success: boolean, message?: string, data?: unknown }>}
   */
  async transcribe(file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/stt/transcribe', formData);
    return response.data;
  }
}

export default new SttService();
